import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 24px 16px;
`;

export const Modal = styled.form`
  background: #fff;
  border-radius: 10px;
  width: 100%;
  max-width: 590px;
  padding: 26px 28px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
`;

export const ModalTitle = styled.h2`
  color: #1b2b3a;
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0 0 10px;
`;

export const Label = styled.label`
  font-size: 0.88rem;
  color: #333;
`;

export const Textarea = styled.textarea`
  padding: 11px 13px;
  border-radius: 6px;
  border: 1px solid #dfe6ec;
  font-size: 0.9rem;
  color: #222;
  outline: none;
  font-family: inherit;
  min-height: 82px;
  resize: vertical;
  width: 100%;
  box-sizing: border-box;

  &:focus { border-color: #26A9B6; }
  &::placeholder { color: #b7c1c9; }
`;

export const Counter = styled.p`
  margin: 0;
  font-size: 0.76rem;
  color: #9aa7b2;
  text-align: right;
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 22px;
`;

export const CancelButton = styled.button`
  padding: 9px 22px;
  border-radius: 6px;
  border: 1.5px solid #26A9B6;
  background: #fff;
  color: #26A9B6;
  font-size: 0.85rem;
  cursor: pointer;

  &:hover { background: #f0fbfc; }
`;

export const SaveButton = styled.button`
  padding: 9px 22px;
  border-radius: 6px;
  border: none;
  background: #1b6b78;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #175a65; }
  &:disabled { background: #8b8b8b; cursor: not-allowed; }
`;
